import IdleTimer from 'react-idle-timer';
import React, { useState, useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { Modal, Button } from "antd";
import CountdownTimer from './utils/CountTimer';
import AlarmClockIcon from './assets/alarm-clock.png'

const IdleTime = () => {
    const idleTimer = useRef(null);

    const isLoginPage = () => {
        const currentPath = window.location.hash;
        return ['/login', '#/login'].includes(currentPath);
    };

    const handleLogout = () => {
        Cookies.remove("is_logged_in");
        Cookies.remove("user_info");
        window.location.replace("app#/login");
        Modal.destroyAll();
    };

    const onIdle = () => {
        if (!isLoginPage()) {
            Modal.confirm({
                // title: 'Session Time-out!',
                title: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginLeft: "-2px" }}>
                        <img
                            src={AlarmClockIcon}
                            alt="Alarm Clock"
                            style={{ width: '40px', height: '40px' }}
                        />
                        <span>Session Time Out!</span>
                    </div>
                ),
                content: (
                    <CountdownTimer
                        initialTime={120}
                        handleLogout={handleLogout}
                    />
                ),
                icon: null, //set default icon to null
                cancelText: 'Log-out',
                okText: 'Stay Logged-in',
                onCancel: handleLogout,
            });
        }
    };

    return (
        <IdleTimer
            ref={idleTimer}
            timeout={41688000} // 11 hour 58 min
            onIdle={onIdle}
            debounce={250}
            crossTab={true}
            syncTimers={500}
        />
    );
};

export default IdleTime;




// WEBPACK FOOTER //
// ./src/IdleTimer.js